<template>
  <div class="ms-container">
    <div class="filters-bar">
      <module-header style="margin-bottom: 0">Платежи</module-header>
      <payments-filter />
    </div>
    <div class="payments-all">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить список платежей. Повторите, пожалуйста, попытку
        позже
      </div>
      <payments-list
        :payments="payments"
        :all="true"
        v-else-if="payments.length"
        @open-payment="openPayment"
      />
      <div v-else class="ms-nodata ms-text">
        Платежи отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import ModuleHeader from '@/components/parts/module-header'
import PaymentsList from '@/components/payments/payments-list'
import InlineLoader from '@/components/loaders/inline-loader'
import PaymentsFilter from '@/components/filters/payments'
import { getPaymentsUrl } from '@/config/filters'

export default {
  components: {
    ModuleHeader,
    PaymentsList,
    InlineLoader,
    PaymentsFilter
  },
  data () {
    return {
      loading: false,
      nodata: false,
      payments: []
    }
  },
  watch: {
    '$store.state.filters.payments': {
      handler: function () {
        this.getData(true)
      },
      deep: true
    }
  },
  methods: {
    async getData () {
      try {
        this.loading = true
        const url = getPaymentsUrl(`page/payment?`, this.$store.state.filters.payments)
        this.payments = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    openPayment ({ id, contract_id }) {
      this.$router.push(`/app/contracts/${contract_id}/payments?open=${id}`)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style>
</style>
